<template>
	<div class="public-content order">
		<div class="breadcrumb">拓客订单结算</div>
		<div class="right-main">
			<!--      查询订单-->
			<el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
				<el-row>
					<el-col v-permission="'oms:admin:order:one'" :span="6">
						<el-form-item label="流水号:">
							<el-input v-model="formInline.settlementNo" placeholder="请输入流水号"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="平台号:">
							<el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
								<el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="平台名称:">
							<el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
								<el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="业务:">
							<el-select clearable v-model="formInline.salemanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
								<el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="结算状态:">
							<el-select v-model="formInline.settlementStatus" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<!-- <el-option label="未结算" value="UNSETTLED"></el-option> -->
								<el-option label="结算中" value="IN_PROGRESS"></el-option>
								<el-option label="已结算" value="SETTLED"></el-option>
								<el-option label="拒绝结算" value="REJECTED"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="创建日期:" class="el-date-width">
							<el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
								start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6" class="fn-right form-btn">
						<el-button v-show="settlement" @click="batchSettlementAudit()" round type="primary">结算</el-button>
						<!-- <el-button v-show="batchSettlement" @click="showButton" round type="primary">批量结算</el-button> -->
						<el-button v-show="cancel" @click="hiddenButton" round type="primary">取消</el-button>
						<el-button @click="(queryInfo.pageNum = 1), onSubmit()" round>查询</el-button>
						<el-button @click="exportExcel" round v-if="$hasPermission('oms:admin:orderSettlement:export')">导出Excel</el-button>
					</el-col>
				</el-row>
			</el-form>
			<div class="data-list">
				<el-table ref="multipleTable" :data="tableData" fit border :row-class-name="rowClassName" style="width: 100%" @selection-change="handleSelectionChange">
					<!-- <el-table-column v-show="settlement" type="selection" width="55"></el-table-column> -->
					<el-table-column prop="settlementNo" label="流水号" min-width="180px"></el-table-column>
					<el-table-column prop="storeCode" label="平台号" min-width="100px">
						<template slot-scope="scope"> {{ scope.row.store.code }} </template>
					</el-table-column>
					<el-table-column prop="storeName" label="平台名称" min-width="130px">
						<template slot-scope="scope"> {{ scope.row.store.name }} </template>
					</el-table-column>
					<el-table-column prop="amount" label="结算价格" min-width="100px"></el-table-column>
					<el-table-column label="结算状态" min-width="100px">
						<template slot-scope="scope"> {{ scope.row.settlementStatus === 'UNSETTLED' ? '未结算' : scope.row.settlementStatus === 'IN_PROGRESS' ? '结算中' : scope.row.settlementStatus === 'SETTLED' ?
								'已结算' : scope.row.settlementStatus === 'REJECTED' ? '拒绝结算' : '未定义'
						}} </template>
					</el-table-column>
					<el-table-column prop="dateCreated" label="创建日期" min-width="170px"></el-table-column>
					<!-- <el-table-column prop="remark" label="备注" min-width="200px"></el-table-column> -->
					<el-table-column label="操作" min-width="100px">
						<template v-slot="scope">
							<span class="color-blue" v-if="scope.row.settlementStatus !== 'SETTLED'" @click="chack(scope.row)">详情</span>
							<!-- <router-link v-if="scope.row.settlementStatus !== 'SETTLED'" :to="{
								path: './TKOrderSettlementDetail',
								query: {
									id: scope.row.settlementNo
								}
							}" class="color-blue">详情</router-link> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--    分页-->
			<v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
		</div>
		<order-dialog ref="orderDialogRef"></order-dialog>
		<!-- <applyDialog ref='applyDialog'></applyDialog>-->
	</div>
</template>
<script>
// import applyDialog from '@/components/RightContent/HQAdmin/OrderManagement/TKOrder/applyDialog.vue'
import VPagination from '@/components/Pagination/index.vue'
import OrderDialog from '@/components/Dialog/OrderDialog/OrderStatusDialog/index.vue'
import { settlementOrderExport, settlementOrder, settlementBatchAudit } from '@/api/oms'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName, vipStoreUpdateStore } from '@/api/crm'

export default {
	name: 'order',
	components: {
		VPagination,
		OrderDialog
		// applyDialog
	},
	watch: {
		value2: {
			handler (val, oldVal) {
				console.log(val)
				if (val) {
					this.formInline.dateStart = val[0] + ' 00:00:00'
					this.formInline.dateEnd = val[1] + ' 23:59:59'
				} else {
					this.formInline.dateStart = ''
					this.formInline.dateEnd = ''
				}
			},
			deep: true,
			immediate: true
		}
	},
	data () {
		return {
			settlementId: '',
			submitAuditDate: [],
			multipleSelection: [],
			settlement: false,
			batchSettlement: true,
			cancel: false,
			userList: [],
			salemanList: [],
			storeListByCode: [],
			queryInfo: {
				total: 0,
				pageNum: 1, // 当前显示第几页
				pageSize: 10 // 每一页显示条数
			},
			formInline: {
				settlementNo: null, // 流水号
				storeId: null,
				dateStart: null,
				dateEnd: null,
				salemanId: null,
				settlementStatus: null // 结算状态
			},
			tableData: [],
			basicsInfo: {
				storeId: '',
				storeCode: '',
				storeName: '',
				fullName: '',
				storeTypeList: []
			},
			value2: [
				// this.$moment()
				// 	.subtract(2, 'months')
				// 	.format('YYYY-MM-DD'),
				// this.$moment()
				// 	.subtract(1, 'months')
				// 	.format('YYYY-MM-DD')
				this.$moment()
					.subtract(6, 'months')
					.format('YYYY-MM-DD'),
				this.$moment().format('YYYY-MM-DD')
			],
			pickerOptions: {
				disabledDate (time) {
					// var threeDate = new Date();
					// threeDate.setMonth(threeDate.getMonth() - 1);
					// return time.getTime() > threeDate - 8.64e6;
					return time.getTime() > Date.now() - 8.64e6
				}
				// shortcuts: [{
				//   text: '最近一周',
				//   onClick(picker) {
				//     const end = new Date()
				//     const start = new Date()
				//     start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
				//     picker.$emit('pick', [start, end])
				//   }
				// }, {
				//   text: '最近一个月',
				//   onClick(picker) {
				//     const end = new Date()
				//     const start = new Date()
				//     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
				//     picker.$emit('pick', [start, end])
				//   }
				// }, {
				//   text: '最近三个月',
				//   onClick(picker) {
				//     const end = new Date()
				//     const start = new Date()
				//     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
				//     picker.$emit('pick', [start, end])
				//   }
				// }]
			}
		}
	},
	created () {
		if (sessionStorage.getItem('searchFlag') === 'true') {
			this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
			this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
			this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
			this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))

			this.value2[0] = this.formInline.dateStart.split(' ')[0]
			this.value2[1] = this.formInline.dateEnd.split(' ')[0]
			sessionStorage.removeItem('searchFlag')
		} else {
			// 首次进入列表页,清除缓存中的搜索条件
			sessionStorage.removeItem('queryParams')
			sessionStorage.removeItem('queryInfo')
			sessionStorage.removeItem('storeListByCode')
			sessionStorage.removeItem('salemanList')
		}
		if (this.$route.query.paymentStatus === 'UNPAID') {
			this.formInline.paymentStatus = 'UNPAID'
			this.formInline.orderStatus = 'SUBMITTED'
		}
		this.onSubmit(this.queryInfo)
	},
	destroyed () {
		// 销毁
		console.log('页面销毁')
		sessionStorage.removeItem('searchFlag')
	},
	methods: {
		chack (row) {
			sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
			sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
			sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
			sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
			this.$router.push({ path: '/TKOrderSettlementDetail', query: { id: row.settlementNo } })
		},
		handleSelectionChange (val) {
			this.multipleSelection = val
		},
		batchSettlementAudit () {
			if (this.multipleSelection.length < 1) {
				this.$message.error('请选择结算订单')
			}

			// data是要被分组的数据[]，key是分组依据的关键字
			//  let data = this.multipleSelection
			//  let getGroup = (data, storeId) => {
			//    let groups = {};
			//    data.forEach(c => {
			//      let value = c[storeId];
			//      groups[value] = groups[value] || [];
			//      groups[value].push(c);
			//    });
			//    console.log(groups)
			//    return groups;
			//  }

			// let storeInfo = [];
			// let tempStoreInfo = [];
			let settlement = ''
			for (let i = 0; i < this.multipleSelection.length; i++) {
				// let oneStoreInfo = {};
				// if (tempStoreInfo.indexOf(this.multipleSelection[i].storeId) === -1) {
				//   tempStoreInfo.push(this.multipleSelection[i].storeId)
				// }
				settlement += this.multipleSelection[i].settlementId + ','
			}
			if (settlement !== '') {
				let auditInfo = {
					settlementIds: settlement,
					auditStatus: 'AUDITED'
				}
				settlementBatchAudit(auditInfo).then(res => {
					if (res.data.success) {
						this.$message.success('修改成功')
						this.$router.go(-1)
					}
				})
			}
		},
		showButton () {
			this.cancel = true
			this.batchSettlement = false
			this.settlement = true
			this.formInline.settlementStatus = 'UNSETTLED'
			this.onSubmit()
		},
		hiddenButton () {
			this.cancel = false
			this.batchSettlement = true
			this.settlement = false
			this.formInline.settlementStatus = null
			this.onSubmit()
		},
		onSubmit () {
			if (sessionStorage.getItem('searchFlag')) {
				sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
				sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
				sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
				sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
			}
			console.log(Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value])))
			settlementOrder({
				page: this.queryInfo.pageNum - 1,
				size: this.queryInfo.pageSize,
				vo: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
			}).then(res => {
				this.queryInfo.total = res.data.data.total
				this.tableData = res.data.data.content
			})
		},
		rowClassName ({ row, rowIndex }) {
			row.index = rowIndex
		},
		getOrderStatus (orderId) {
			this.$refs.orderDialogRef.show(orderId)
		},
		exportExcel () {
			const loading = this.$loading({
				lock: true,
				text: '正在导出表格，请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			let param = JSON.parse(JSON.stringify(this.formInline))
			// if (!param.dateStart) {
			//   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD') + ' 00:00:00'
			//   param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
			// }
			Object.keys(param).forEach(key => (param[key] === '' || param[key] === null) && delete param[key])
			settlementOrderExport(param).then(res => {
				let blob = res.data
				const fileReader = new FileReader()
				fileReader.readAsDataURL(blob)
				fileReader.onload = event => {
					let a = document.createElement('a')
					let _fileName = '拓客订单结算表' + this.value2[0] + '-' + this.value2[1] + '.xls'
					a.download = _fileName
					a.href = event.target.result
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
					loading.close()
				}
			})
		},
		handleSelect (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeName = item.companyName
		},
		selectUserList (val) {
			if (val.trim()) {
				getAllUsersByUserName(val).then(res => {
					if (res.data.success) {
						this.userList = res.data.data
					}
				})
			}
		},
		selectSalemanList (val) {
			if (val.trim()) {
				getSalesmanByFullName(val).then(res => {
					if (res.data.success) {
						this.salemanList = res.data.data
					}
				})
			}
		},
		filterMethod (val) {
			if (val.trim()) {
				storeQueryListByCode(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		filterByName (val) {
			if (val.trim()) {
				storeQueryListByName(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		// querySearchAsync(queryString, cb) {
		//   storeQueryListByCode(queryString).then(res => {
		//     res.data.data.forEach(item => {
		//       item.value = item.code
		//     });
		//     cb(res.data.data)
		//   })
		// },
		SelectStoreName (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeCode = item.code
		},
		queryStoreNameAsync (queryString, cb) {
			storeQueryListByName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.code
				})
				cb(res.data.data)
			})
		},
		selectFullName (item) {
			this.formInline.salemanId = item.id
		},
		queryFullNameAsync (queryString, cb) {
			// 改成业务的模糊查询
			getSalesmanByFullName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.fullName
				})
				cb(res.data.data)
			})
		},
		changePage (val) {
			this.queryInfo = val
			this.onSubmit()
		}
	}
}
</script>
<style scoped lang="less">
@deep: ~'>>>';

@{deep} .data-list .el-table tr td {
	height: 40px !important;
	padding: 0 !important;
	;
}
</style>
